export default function (isInit = false,callback) {
  const wrapper = document.querySelector('.onlineuser-list')
  const first = wrapper.querySelector('.onlineuser-list-item')
  const last = wrapper.querySelector('.onlineuser-list-item:last-child')
  if (first === last) {
    first.style.height = '100%'
    return
  }
  const firstTab = first.querySelector('[role="tab"]')
  const lastTab = last.querySelector('[role="tab"]')
  const dic = document.createElement('div')
  dic.className = 'can-move-cursor'
  last.insertBefore(dic, lastTab)
  let lastH = 0
  let moveY = 0
  let isMove = !isInit

  /**
   * 鼠标滑动更新计算高度
   * @param {*} e 
   */
  const move = (e) => {
    isMove = true
    let y = e.clientY
    const { bottom } = last.getBoundingClientRect()
    if (y > bottom - lastTab.offsetHeight) return
    update(last, first, -(y - moveY) + lastH)
    check()
  }

  /**
   * 更新元素高度百分比
   * @param {*} a 
   * @param {*} b 
   * @param {*} height 
   */
  function update(a, b, height) {
    const percent = height / wrapper.offsetHeight * 100
    a.style.height = percent + '%'
    b.style.height = 100 - percent + '%'
    callback()
  }

  /**
   * 检查高度边界
   */
  function check() {
    const { height } = firstTab.getBoundingClientRect()
    if (first.offsetHeight < height) {
      update(first, last, height)
    }
    if (last.offsetHeight < height) {
      update(last, first, height)
    }
  }

  function mousedown(e) {
    moveY = e.clientY
    lastH = last.offsetHeight
    document.addEventListener('mousemove', move)
    document.addEventListener('mouseup', () => {
      document.removeEventListener('mousemove', move)
    })
  }

  dic.addEventListener('mousedown', mousedown)

  function resize() {
    if (!isMove) return
    check()
  }

  window.addEventListener('resize', resize)

  if (isInit) {
    first.style.height = '50%'
  }

  return () => {
    dic.removeEventListener('mousedown', mousedown)
    window.removeEventListener('resize', resize)
  }

}